export var PACKAGE_VERSION = "9.8.1";
//# sourceMappingURL=constants.js.map